import React, { useState } from 'react';
import './Header.css';
import logoSvg from '../assests/logo/default.svg';

function Header({ onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (id) => {
    // First navigate to home if we're on a legal page
    if (onNavigate) {
      onNavigate('home');
    }
    
    // Then scroll to the section
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
      }
    }, 0);
  };

  const handleLogoClick = () => {
    if (onNavigate) {
      onNavigate('home');
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <button className="logo" onClick={handleLogoClick} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          <img src={logoSvg} alt="Northstar Bridge Commerce" className="logo-img" />
          <h1>Northstar Bridge Commerce</h1>
        </button>

        <button
          className={`hamburger ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <button onClick={() => handleNavClick('hero')} className="nav-link">Home</button>
          <button onClick={() => handleNavClick('consumer-categories')} className="nav-link">Categories</button>
          <button onClick={() => handleNavClick('wholesale-trading')} className="nav-link">Distribution</button>
          <button onClick={() => handleNavClick('partnerships')} className="nav-link">Partnerships</button>
          <button onClick={() => handleNavClick('contact')} className="nav-link">Contact</button>
        </nav>

        <button 
          className="cta-button"
          onClick={() => handleNavClick('contact')}
        >
          Supplier Inquiry
        </button>
      </div>
    </header>
  );
}

export default Header;
